/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portals_Preview_Photos_HintInputs */

const cs_portals_preview_photos_hint = /** @type {(inputs: Portals_Preview_Photos_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Export použije ${i?.count} fotek z galerie (první = cover).`)
};

const en_portals_preview_photos_hint = /** @type {(inputs: Portals_Preview_Photos_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Export will use ${i?.count} gallery photos (first = cover).`)
};

/**
* | output |
* | --- |
* | "Export will use {count} gallery photos (first = cover)." |
*
* @param {Portals_Preview_Photos_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview_photos_hint = /** @type {((inputs: Portals_Preview_Photos_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Preview_Photos_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview_photos_hint(inputs)
	return cs_portals_preview_photos_hint(inputs)
});